/**
 * @constant vehicle properties array, if the property is in a nested object, add the path of the property separated by '.'
 */
export const vehicleProperties = [
  {
    label: 'vin',
    properties: ['vehicle.vin']
  },
  {
    label: 'generation',
    properties: ['generation']
  },
  {
    label: 'model-code',
    properties: ['model.modelCode', 'modelCode'],
  },
  {
    label: 'build-date',
    properties: ['manufacturedDate']
  },
  {
    label: 'access-blocked',
    properties: ['vehicle.accessBlocked']
  },
  {
    label: 'access-update',
    properties: ['vehicle.accessUpdate'],
  },
  {
    label: 'access-updated',
    properties: ['vehicle.accessUpdated'],
  },
  {
    label: 'cert-mapped',
    properties: ['vehicle.certMapped'],
  },
  {
    label: 'chipId',
    properties: ['vehicle.chipId'],
  },
  {
    label: 'huId',
    properties: ['vehicle.huId'],
  },
  {
    label: 'hucom-header',
    properties: ['vehicle.hucomHeader'],
  },
];
/**
 * @constant headUnit properties array, if the property is in a nested object, add the path of the property separated by '.'
 */
export const headUnitProperties = [

  {
    label: 'head-unit-type',
    properties: ['headUnit.huVersion'],
    telematics: true
  },
  {
    label: 'mpc',
    properties: ['headUnit.mobilePlatformCode'],
    telematics: true
  },
  {
    label: 'head-unit',
    properties: ['headUnit.huDescription'],
    telematics: true
  }
];
/**
 * @constant dcmInfo properties array, if the property is in a nested object, add the path of the property separated by '.'
 */
export const dcmInfoProperties = [
  {
    label: 'imei',
    properties: ['imei'],
    telematics: true
  },
  {
    label: 'manufacturer',
    properties: ['dcm.dcmSupplierName'],
    telematics: true
  }
];

